import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import themes from "../context/themes";

/**
 * Opções de tema MUI com rótulos traduzidos (namespace `themes`, chave = id do tema em themes.js).
 */
export function useTranslatedThemeOptions() {
  const { t, i18n } = useTranslation("themes");
  return useMemo(
    () =>
      Object.keys(themes).map((value) => ({
        value,
        label: t(value, { defaultValue: value.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()) }),
      })),
    [t, i18n.language]
  );
}
